/**
 * Tabbed Content Pattern
 * Switch active tab and show corresponding content panel on click.
 */
$(document).ready(function () {
  $(document).on('click', '.pattern-tabbed-content .tbc-tab', function () {
    var $tab = $(this);
    var index = $tab.data('tab');
    var $pattern = $tab.closest('.pattern-tabbed-content');

    $pattern.find('.tbc-tab').removeClass('active');
    $pattern.find('.tbc-panel').removeClass('active');

    $tab.addClass('active');
    $pattern.find('.tbc-panel[data-panel="' + index + '"]').addClass('active');
  });
});
